
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.858 24.392c3.313 5.74 10.652 7.706 16.392 4.393 5.74-3.314 7.706-10.653 4.392-16.393C25.33 6.652 17.99 4.686 12.25 8","stroke":"#424242","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M7.97 9.78l3.418-3.914 1.682 4.916-5.1-1.002z","fill":"#424242"}})])
          )
        }
      }
    